export enum EApplicationUrls {
  APPLICATION = 'application',
  STEP = 'step',
  VERIFY = 'verify',
  ANIMAL = 'animal',
  DETAILS = 'details',
  TENANT = 'tenant',
  PAYMENT = 'payment',
  LEASE_PACKET = 'lease-packet',
  PROPERTIES = 'properties',
  PROPERTY = 'property',
  UNITS = 'units',
  METRIC = 'metric',
  SIGN = 'sign',
  PROPERTY_MANAGEMENT = 'property-management',
}
